import { ICON_CONST } from './IconWrapper.d';
import { Icon } from './IconWrapper.styles';
import type { IconWrapperProps } from './IconWrapper.d';

export const IconWrapper = ({ children, color, textAlign, ...props }: IconWrapperProps) => (
  <Icon.Wrapper
    data-color={color}
    data-testid={ICON_CONST.TEST_ID}
    data-text-align={textAlign}
    {...props}
  >
    {children}
  </Icon.Wrapper>
);

export default IconWrapper;
